// src/utils/slugify.ts

/**
 * Converts a string into a URL-friendly slug.
 * Example: "Image Generation & Editing" -> "image-generation-editing"
 */
const slugify = (text: string): string =>
  text.replace(/[^\w\s-]/g, '') // Remove non-word, non-space, non-hyphen
      .replace(/\s+/g, '-')     // Replace spaces with hyphens
      .toLowerCase();           // Convert to lowercase

export default slugify;
